import React, { useState } from "react";
import moment from "moment";
import {
  Button,
  ChoiceList,
  Labelled,
  Popover,
  Stack,
  TextField,
} from "@shopify/polaris";
import { CalendarMinor } from "@shopify/polaris-icons";
import { getDateRange, isValidDateRange, TIME_OPTIONS } from "./date-range";

export default function EtsyMetricTimeFilter({ value, dateRange, onChange }) {
  const [active, setActive] = useState(false);
  const [draftPreset, setDraftPreset] = useState(value);
  const [draftRange, setDraftRange] = useState(dateRange);
  const fromLabel = moment(dateRange.from, "YYYY-MM-DD").format("DD-MM-YYYY");
  const toLabel = moment(dateRange.to, "YYYY-MM-DD").format("DD-MM-YYYY");
  const rangeLabel =
    dateRange.from === dateRange.to ? fromLabel : `${fromLabel} – ${toLabel}`;

  return (
    <Labelled
      id="etsy-metric-time-filter"
      label="Time range"
      helpText={<span aria-live="polite">{rangeLabel}</span>}
    >
      <Popover
        active={active}
        onClose={() => setActive(false)}
        activator={
          <Button
            id="etsy-metric-time-filter"
            icon={CalendarMinor}
            disclosure
            onClick={() => {
              setDraftPreset(value);
              setDraftRange(dateRange);
              setActive(!active);
            }}
          >
            {value === "Custom time"
              ? `${dateRange.from} – ${dateRange.to}`
              : value}
          </Button>
        }
        sectioned
      >
        <ChoiceList
          title="Time range"
          choices={TIME_OPTIONS.map((label) => ({ label, value: label }))}
          selected={[draftPreset]}
          onChange={([selected]) => {
            setDraftPreset(selected);
            if (selected !== "Custom time") {
              onChange(selected, getDateRange(selected));
              setActive(false);
            }
          }}
        />
        {draftPreset === "Custom time" && (
          <Stack vertical>
            <TextField
              label="From"
              type="date"
              value={draftRange.from}
              onChange={(from) =>
                setDraftRange((previous) => ({ ...previous, from }))
              }
            />
            <TextField
              label="To"
              type="date"
              value={draftRange.to}
              onChange={(to) =>
                setDraftRange((previous) => ({ ...previous, to }))
              }
              error={
                !isValidDateRange(draftRange)
                  ? "Choose valid dates with From on or before To."
                  : undefined
              }
            />
            <Button
              primary
              disabled={!isValidDateRange(draftRange)}
              onClick={() => {
                onChange("Custom time", draftRange);
                setActive(false);
              }}
            >
              Apply
            </Button>
          </Stack>
        )}
      </Popover>
    </Labelled>
  );
}
